export const COOKIE_CONSENT_MAX_AGE_MS = 6 * 30 * 24 * 60 * 60 * 1000;

/**
 * One validity rule for every consumer of the stored cookie preference.
 * Legacy consent without a timestamp must be renewed before it is used.
 */
export function isCookieConsentValid(prefs, now = Date.now()) {
  if (!prefs?.timestamp) return false;
  const timestamp = new Date(prefs.timestamp).getTime();
  return (
    Number.isFinite(timestamp) && now - timestamp <= COOKIE_CONSENT_MAX_AGE_MS
  );
}
